import React, { Component } from 'react';

export default class SpendSummaryItem extends Component {

	render() {
		const { title, money, color, icon, onClick } = this.props;

		const spendClasses = 'collection-item';
		return (
			<div
				onClick={onClick}
				className={`spent waves-effect clickable ${spendClasses}`}>
				<div className='main'>
					{!!icon && <i className={`material-icons money_display ${color}`}>{icon}</i>}
					<span className='title'>{title}</span>{' '}
					{money}
				</div>
			</div>
		);
	}

}